import {transform, isEqual, isArray, isObject} from 'lodash';

/**
 * Find difference between two objects
 * @param  {object} origObj - Source object to compare newObj against
 * @param  {object} newObj  - New object with potential changes
 * @return {object} differences
 */
export const difference = <A, B>(origObj: A, newObj: B): Partial<A & B> => {
    function changes<A, B>(origData: A, newData: B): Partial<A & B> {
        let arrayIndexCounter = 0;
        // @ts-expect-error
        return transform(newData, function (result, value, key) {
            // @ts-expect-error
            if (!isEqual(value, origData[key])) {
                const resultKey = isArray(origData) ? arrayIndexCounter++ : key;
                // @ts-expect-error
                result[resultKey] = (isObject(value) && isObject(origData[key])) ? changes(origData[key], value) : value;
            }
        });
    }
    return changes(origObj, newObj);
};
